/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Criticality } from './Criticality';
import type { StatsOperationDatasetDto } from './StatsOperationDatasetDto';

export type StatsOperationFailingMonitorDto = {
    criticality: Criticality;
    datasets: Array<StatsOperationDatasetDto>;
    failureCount: number;
    id: string;
    lastFailureDate: number;
    name: string;
    ruleLabel: string;
    ruleTemplateName: string;
    status: StatsOperationFailingMonitorDto.status;
};

export namespace StatsOperationFailingMonitorDto {

    export enum status {
        NOT_EVALUATED = 'NOT_EVALUATED',
        PASSING = 'PASSING',
        NEEDS_ATTENTION = 'NEEDS_ATTENTION',
        FAILING = 'FAILING',
    }


}
